/* eslint-disable camelcase */
import { STATES_COLORS, STATIC_DATA_STATES } from '../charts/chart-components'
import { timestampToDateTime } from './parse'
import {
    RawInterventionEvent,
    RawPhaseEvent,
    RawRigTableEvent,
    RawRunEvent,
    RawActivityEvent,
    RawEmptyEvent,
    xRangeEvent
} from './type'

export const DISABLED_EMPTY_DATA = (start: number, end: number) => [
    {
        name: 'empty',
        color: STATES_COLORS[STATIC_DATA_STATES.EMPTY_DISABLED],
        x: start,
        x2: end,
        y: 0,
        rawEvent: { start: start, end: end, state: STATIC_DATA_STATES.EMPTY_DISABLED }
    }
]

export const EMPTY_DATA = (
    start: number,
    end: number,
    state: STATIC_DATA_STATES,
    parentData: xRangeEvent | null
): xRangeEvent[] => {
    if (end <= start) return []

    return [
        {
            name: 'empty',
            color: STATES_COLORS[state],
            x: start,
            x2: end,
            y: 0,
            isRealtime: !!parentData?.isRealtime,
            rawEvent: { start: start, state: state },
            parentStart: parentData?.x
        }
    ]
}

export const INTERVENTION_EMPTY_DATA = (start: number, end: number, rigId: number) => {
    if (end <= start) return []

    return [
        {
            name: 'empty',
            color: STATES_COLORS[STATIC_DATA_STATES.EMPTY],
            x: start,
            x2: end,
            y: 0,
            rawEvent: { start: start, state: STATIC_DATA_STATES.EMPTY, rig_id: rigId }
        }
    ]
}

export const MOCKED_EMPTY_DATA: any = [
    {
        name: 'empty',
        color: STATES_COLORS[STATIC_DATA_STATES.EMPTY],
        x: 0,
        x2: 3600000,
        y: 0,
        rawEvent: { begin: 0, end: 3600000, state: STATIC_DATA_STATES.EMPTY }
    }
]

export const MOCKED_INTERVENTION_DATA: Array<RawInterventionEvent | RawEmptyEvent> = [
    {
        begin: 0,
        end: 3600000,
        state: STATIC_DATA_STATES.EMPTY
    },
    {
        begin: 0,
        end: 3600000,
        name: 'Well Top Hole Drilling 1',
        tatic: { value: 'Startup' },
        responsible: 'Thales',
        well: {
            wellName: '8-LL-38D-RJS',
            field: 'Lula',
            depth: '350',
            type: 'Offshore',
            category: 'Production',
            position: 'Latitude',
            reference: 'SIRGAS2000'
        },
        state: STATIC_DATA_STATES.STARTED_IN_EXECUTION
    }
    // {
    //     begin: 1000000,
    //     end: 2000000,
    //     name: 'Well Top Hole Drilling 2',
    //     purpose: { value: 'Completion' },
    //     responsible: 'Camila',
    //     wellProperties: {
    //         wellName: '8-LL-38D-RJS',
    //         field: 'Lula',
    //         depth: '353',
    //         type: 'Onshore',
    //         category: 'Wildcat',
    //         position: 'Longitude',
    //         reference: 'WGS54'
    //     }
    // },
    // {
    //     begin: 2000000,
    //     end: 3600000,
    //     name: 'Well Top Hole Drilling 3',
    //     purpose: { value: 'Completion' },
    //     responsible: 'Agente',
    //     wellProperties: {
    //         wellName: '8-LL-38D-RJS',
    //         field: 'Lula',
    //         depth: '355',
    //         type: 'Onshore',
    //         category: 'Injection',
    //         position: 'Longitude',
    //         reference: 'WGS54'
    //     }
    // }
]

const phase_base_data = {
    beginMeasuredDepth: { value: 12, uom: 'm' },
    finalMeasuredDepth: { value: 33, uom: 'm' },
    riser: true
}

export const MOCKED_PHASE_DATA: Array<RawPhaseEvent | RawEmptyEvent> = [
    {
        begin: 0,
        end: 3600000,
        state: STATIC_DATA_STATES.EMPTY,
        interventionStartDate: timestampToDateTime(0).date,
        interventionStartHour: timestampToDateTime(0).time
    },
    {
        name: 'Section 1',
        begin: 0,
        end: 1200000,
        outsideDiameter: { value: '22', uom: 'in' },
        previousOutsideDiameter: { value: null, uom: null },
        previousCasingOutsideDiameter: { value: null, uom: null },
        previousCasingFinalMeasuredDepth: { value: null, uom: null },
        casingOutsideDiameter: { value: 25, uom: 'cm' },
        casingFinalMeasuredDepth: { value: 1, uom: 'm' },
        ...phase_base_data,
        state: STATIC_DATA_STATES.FINISHED
    }
    // {
    //     name: 'Section 2',
    //     begin: 1200000,
    //     end: 2400000,
    //     outsideDiameter: { value: '30', uom: 'in' },
    //     previousOutsideDiameter: { value: '22', uom: 'in' },
    //     previousCasingOutsideDiameter: { value: 25, uom: 'cm' },
    //     previousCasingFinalMeasuredDepth: { value: 1, uom: 'm' },
    //     casingOutsideDiameter: { value: 30, uom: 'cm' },
    //     casingFinalMeasuredDepth: { value: 3, uom: 'm' },
    //     ...phase_base_data
    // },
    // {
    //     name: 'Section 3',
    //     begin: 2400000,
    //     end: 3600000,
    //     outsideDiameter: { value: '45', uom: 'in' },
    //     previousOutsideDiameter: { value: '30', uom: 'in' },
    //     previousCasingOutsideDiameter: { value: 30, uom: 'cm' },
    //     previousCasingFinalMeasuredDepth: { value: 3, uom: 'm' },
    //     casingOutsideDiameter: { value: 35, uom: 'cm' },
    //     casingFinalMeasuredDepth: { value: 5, uom: 'm' },
    //     ...phase_base_data
    // }
]

export const MOCKED_RIG_TABLE_DATA: Array<RawRigTableEvent | RawEmptyEvent> = [
    {
        begin: 0,
        end: 3600000,
        state: STATIC_DATA_STATES.EMPTY,
        interventionStartDate: timestampToDateTime(0).date,
        interventionStartHour: timestampToDateTime(0).time
    }
    // {
    //     type: 'Main',
    //     status: 'RPI Relevant Path',
    //     begin: 0,
    //     end: 1200000,
    //     reason: 'Testing description...',
    // }
    // {
    //     type: 'Main',
    //     status: 'RPI Non-Relevant Path',
    //     begin: 1200000,
    //     end: 2400000,
    //     reason: ''
    // },
    // {
    //     type: 'Main',
    //     status: 'RPI Non-Relevant Path',
    //     begin: 2400000,
    //     end: 3600000,
    //     reason: ''
    // },
]

export const MOCKED_RUN_DATA: Array<RawRunEvent | RawEmptyEvent> = [
    {
        // isStarted: true,
        tubularInterval: false,
        state: STATIC_DATA_STATES.CREATED_NOT_INITIALIZED,
        number: '0',
        beginMeasuredDepth: { value: 12, uom: 'm' },
        finalMeasuredDepth: { value: 33, uom: 'm' },
        begin: 0,
        end: 600000,
        type: { value: 'Jet Drilling' }
    },
    {
        tubularInterval: true,
        state: STATIC_DATA_STATES.VALIDATED_GOLDEN_DB,
        number: '1',
        beginMeasuredDepth: { value: 33, uom: 'm' },
        finalMeasuredDepth: { value: 52, uom: 'm' },
        begin: 600000,
        end: 800000,
        type: { value: 'Drilling' }
    },
    {
        state: STATIC_DATA_STATES.ALERTED,
        number: '2',
        beginMeasuredDepth: { value: 52, uom: 'm' },
        finalMeasuredDepth: { value: 73, uom: 'm' },
        begin: 800000,
        end: 1500000,
        type: { value: 'Casing' }
    },
    {
        tubularInterval: true,
        state: STATIC_DATA_STATES.FINISHED,
        number: '3',
        beginMeasuredDepth: { value: 73, uom: 'm' },
        finalMeasuredDepth: { value: 92, uom: 'm' },
        begin: 300000,
        end: 3600000,
        type: { value: 'Riser' }
    },
    {
        tubularInterval: false,
        number: '4',
        beginMeasuredDepth: { value: 92, uom: 'm' },
        finalMeasuredDepth: { value: 123, uom: 'm' },
        begin: 3000000,
        end: 3600000,
        state: STATIC_DATA_STATES.STARTED_WITHOUT_KPI
    }
    // {
    //     number: '0',
    //     beginMeasuredDepth: { value: 12, uom: 'm' },
    //     finalMeasuredDepth: { value: 33, uom: 'm' },
    //     begin: 0,
    //     end: 600000,
    //     type: { value: 'Jet Drilling' }
    // },
    // {
    //     number: '1',
    //     beginMeasuredDepth: { value: 33, uom: 'm' },
    //     finalMeasuredDepth: { value: 52, uom: 'm' },
    //     begin: 600000,
    //     end: 800000,
    //     type: { value: 'Drilling' }
    // },
    // {
    //     number: '2',
    //     beginMeasuredDepth: { value: 52, uom: 'm' },
    //     finalMeasuredDepth: { value: 73, uom: 'm' },
    //     begin: 800000,
    //     end: 1500000,
    //     type: { value: 'Casing' }
    // },
    // {
    //     number: '3',
    //     beginMeasuredDepth: { value: 73, uom: 'm' },
    //     finalMeasuredDepth: { value: 92, uom: 'm' },
    //     begin: 1500000,
    //     end: 3000000,
    //     type: { value: 'Riser' }
    // },
    // {
    //     number: '4',
    //     beginMeasuredDepth: { value: 92, uom: 'm' },
    //     finalMeasuredDepth: { value: 123, uom: 'm' },
    //     begin: 3000000,
    //     end: 3600000,
    //     type: { value: 'Completion' }
    // }
]

export const MOCKED_ACTIVITY_DATA: Array<RawActivityEvent | RawEmptyEvent> = [
    // {
    //     begin: 0,
    //     end: 3600000,
    //     state: STATIC_DATA_STATES.EMPTY_DISABLED
    // }
    {
        id: 1,
        tubular: 'Casing Running',
        oD: { value: '36', uom: 'pol' },
        begin: 0,
        end: 300000,
        thirdPartyResponsible: 'Camila',
        restrictedConnections: [
            {
                connection: 'Restricted',
                begin: 0,
                end: 300000
            },
            {
                connection: 'Restricted',
                begin: 0,
                end: 300000
            }
        ],
        restrictedPipeMovements: [
            {
                pipe: 'Restricted',
                speed: '2000 m/h',
                begin: 300000,
                end: 300000
            },
            {
                pipe: 'Restricted',
                speed: '2000 m/h',
                begin: 300000,
                end: 300000
            }
        ],
        material: 'Spacial Alloy',
        state: STATIC_DATA_STATES.CREATED_NOT_INITIALIZED,
        runId: 1,
        finished: false
    },
    {
        id: 2,
        tubular: 'BHA',
        oD: { value: '28', uom: 'pol' },
        begin: 300000,
        end: 1400000,
        thirdPartyResponsible: 'Camila',
        restrictedConnections: [
            {
                connection: 'Restricted',
                begin: 0,
                end: 300000
            },
            {
                connection: 'Restricted',
                begin: 0,
                end: 300000
            }
        ],
        restrictedPipeMovements: [
            {
                pipe: 'Restricted',
                speed: '2000 m/h',
                begin: 300000,
                end: 300000
            },
            {
                pipe: 'Restricted',
                speed: '2000 m/h',
                begin: 300000,
                end: 300000
            }
        ],
        material: 'Not Aplicable',
        state: STATIC_DATA_STATES.FINISHED,
        runId: 3,
        finished: true
    },
    {
        id: 3,
        tubular: 'DPR Running',
        oD: { value: '26', uom: 'pol' },
        begin: 1400000,
        end: 3600000,
        thirdPartyResponsible: 'Camila',
        restrictedConnections: [
            {
                connection: 'Restricted',
                begin: 0,
                end: 300000
            },
            {
                connection: 'Restricted',
                begin: 0,
                end: 300000
            }
        ],
        restrictedPipeMovements: [
            {
                pipe: 'Restricted',
                speed: '2000 m/h',
                begin: 300000,
                end: 300000
            },
            {
                pipe: 'Restricted',
                speed: '2000 m/h',
                begin: 300000,
                end: 300000
            }
        ],
        material: 'Spacial Alloy',
        state: STATIC_DATA_STATES.CREATED_NOT_INITIALIZED,
        runId: 3,
        finished: true
    }
]
